import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosClient from "../Services/Axios/axios";
import Swal from "sweetalert2";
import { BeatLoader } from "react-spinners";

const EmployeeInviteLink = () => {
  const { id } = useParams();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const acceptInvitation = async () => {
    try {
      setLoader(true);
      const response = await axiosClient.get(
        `employees/${process.env.REACT_APP_API_VERSION}/employee-invite-accept/${id}`
      );
      if (!response.data.error) {
        setLoader(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message,
        });
        navigate("/login");
      } else {
        setLoader(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message,
        });
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
      });
    }
  };

  const rejectInvitation = async () => {
    try {
      setLoader(true);
      const response = await axiosClient.get(
        `employees/${process.env.REACT_APP_API_VERSION}/employee-invite-reject/${id}`
      );
      if (!response.data.error) {
        setLoader(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message,
        });
        navigate("/login");
      } else {
        setLoader(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message,
        });
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
      });
    }
  };

  if (loader) {
    return (
      <div className="loader">
        <BeatLoader color="#097C81" />
      </div>
    );
  }
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="max-w-md w-full bg-white shadow-lg rounded-2xl p-6">
        <div className="flex items-center justify-center mb-6">
          <img
            // src={logoUrl}
            alt="Logo"
            className="h-12 w-auto object-contain"
          />
        </div>

        <p className="text-gray-700">
          Hello <span className="font-semibold"></span>,
        </p>

        <p className="mt-4 text-gray-700">
          You are invited to join <span className="font-semibold"></span>.
        </p>

        <div className="flex gap-4 mt-6">
          <button
            onClick={acceptInvitation}
            className="flex-1 py-2 rounded-lg text-white font-medium bg-teal-600 hover:bg-teal-700 transition"
          >
            Accept Invitation
          </button>

          <button
            onClick={rejectInvitation}
            className="flex-1 py-2 rounded-lg text-white font-medium bg-red-600 hover:bg-red-700 transition"
          >
            Reject Invitation
          </button>
        </div>

        <p className="mt-6 text-sm text-gray-500">
          If you did not expect this invitation, please ignore this email.
        </p>

        <div className="mt-6 text-gray-800">
          <p className="font-medium">Regards,</p>
          <p className="font-semibold">WorldTrust Team</p>
        </div>
      </div>
    </div>
  );
};

export default EmployeeInviteLink;
